import { getAccountPageViewModel } from "./AccountPageViewModel";
import { useSiteConfig } from "../features/tenant/SiteConfigContext";
import { normalizeCustomerAccountCode } from "../lib/lookupCode";
import { routes } from "../lib/route";
import { getApiFailureMessage, getApiFailureName, useGetAccountQuery } from "../store/gboApi";

export function useAccountPage(customerCode?: string) {
  const siteConfig = useSiteConfig();
  const normalizedCustomerCode = customerCode ? normalizeCustomerAccountCode(customerCode) : "";
  const accountQuery = useGetAccountQuery(
    normalizedCustomerCode ? { customerCode: normalizedCustomerCode } : { customerCode: "" },
    { skip: !normalizedCustomerCode },
  );

  if (!normalizedCustomerCode) {
    return {
      status: "empty" as const,
    };
  }

  if (accountQuery.isLoading || accountQuery.isFetching) return { status: "loading" as const };

  if (accountQuery.isError && getApiFailureName(accountQuery.error) === "NotFoundError") {
    return {
      status: "notFound" as const,
      message: getApiFailureMessage(accountQuery.error, "Account not found."),
      returnRoute: routes.search(),
    };
  }

  if (accountQuery.isError) {
    return {
      status: "error" as const,
      message: getApiFailureMessage(accountQuery.error, "Unable to load account."),
    };
  }

  if (!accountQuery.data) {
    return {
      status: "error" as const,
      message: "The account response could not be displayed.",
    };
  }

  return {
    status: "ready" as const,
    customerCode: normalizedCustomerCode,
    viewModel: getAccountPageViewModel(accountQuery.data, siteConfig),
  };
}
